import axios from "axios";

// Use REACT_APP_BACKEND_URL if it matches current origin, otherwise use current origin
// This handles production deployments where the env var might have the preview URL baked in
const configuredUrl = process.env.REACT_APP_BACKEND_URL || "";
const currentOrigin = typeof window !== "undefined" ? window.location.origin : "";
const baseUrl = configuredUrl && configuredUrl.includes(window.location.hostname)
  ? configuredUrl
  : currentOrigin;

const API = axios.create({
  baseURL: `${baseUrl}/api`,
  withCredentials: true,
});

export default API;
